<template>
  <IncomingOrderDetail :is-edit="false" />
</template>

<script>
import IncomingOrderDetail from './detail';

export default {
  name: 'IncomingOrderCreate',
  components: { IncomingOrderDetail },
};
</script>

<style scoped>

</style>
